import { HttpClient } from '@angular/common/http';
import { of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
var EnvironmentService = /** @class */ (function () {
    function EnvironmentService(http, _window) {
        this.http = http;
        this._window = _window;
        this.envModelNull = null;
    }
    EnvironmentService.prototype.loadEnvironment = function () {
        var _this = this;
        if (this.envModel === null || this.envModel === undefined) {
            return this.http.get(this.getUrlEnv()).pipe(map(function (res) {
                if (res) {
                    _this.envModel = res;
                    return _this.envModel;
                }
                else {
                    console.error("enviroment null");
                    return null;
                }
            }), catchError(function (err) {
                console.error("Erro ao recuperar enviroment", err);
                return of(_this.envModelNull);
            }));
        }
        else {
            return of(this.envModel);
        }
    };
    EnvironmentService.prototype.getUrlEnv = function () {
        var routeEnv = '';
        if (this._window.location.hostname.indexOf("ww73hom.itau") > -1) {
            routeEnv += './assets/environment/env.hom.json';
        }
        else if (this._window.location.hostname.indexOf("ww73.itau") > -1 || this._window.location.hostname.indexOf("investmentservices") > -1) {
            routeEnv += './assets/environment/env.prod.json';
        }
        else if (this._window.location.hostname.indexOf("localhost") > -1 || this._window.location.hostname.indexOf("web-jboss-en4-securitiesservices.ctsp.des") > -1) {
            routeEnv += './assets/environment/env.json';
        }
        return routeEnv;
    };
    EnvironmentService.prototype.setEnvModel = function (es) {
        if (es === null || es === undefined) {
            return;
        }
        this.envModel = es;
    };
    return EnvironmentService;
}());
export { EnvironmentService };
